import React from "react";
import { Checkbox } from "react-materialize";
import { useInfo } from "context/InfoContext";

export default function ReportItems({ data, handleEvents }) {
  const { selectAllReport } = useInfo();
  const rep_group_id = parseInt(data.rep_group_id);
  const rep_data = data.rep_data;
  // const rep_group_all_countries = data.rep_group_all_countries;
  const countries = data.countries;
  const user_reports_access = data.user_reports_access;
  const user_countries_access = data.user_countries_access;
  const user_group_relate_report = data.user_group_relate_report;
  const report_countries = data.report_countries;
  const rep_group_ids_checked = [];
  const count_rep = rep_data.length;
  rep_data.forEach((item) => {
    const rep_id = item.rep_id;
    if (user_reports_access.indexOf(rep_id) >= 0) {
      rep_group_ids_checked.push(rep_id);
    }
  });
  let rep_group_checked =
    selectAllReport.rep_group_id === rep_group_id.toString() ? true : false;
  if (
    !rep_group_checked &&
    count_rep > 0 &&
    rep_group_ids_checked.length === count_rep
  ) {
    rep_group_checked = true;
  }
  return (
    <div key={"outer-report-items-" + data.inx} className="row">
      <div key={"report-items-" + data.inx} className="col s12 report-items">
        <div className="col s12">
          <Checkbox
            checked={
              rep_group_checked || selectAllReport.type === "select"
                ? true
                : false
            }
            filledIn
            id={"checkbox-report-group-item-" + rep_group_id}
            name="user_group_reports_access"
            className="checkbox-report-group"
            label={data.rep_group_name}
            value={rep_group_id.toString()}
            onChange={handleEvents.OnChange}
          />
        </div>
      </div>
      {rep_data.map((item, i) => {
        const rep_id = item.rep_id;
        const rep_checked =
          user_reports_access.indexOf(rep_id) >= 0 ||
          user_reports_access.indexOf(rep_id.toString()) >= 0 ||
          (rep_group_checked && selectAllReport.type === "select")
            ? true
            : false;
        const rep_disable =
          user_group_relate_report.indexOf(rep_id) >= 0 ||
          user_group_relate_report.indexOf(rep_id.toString()) >= 0
            ? true
            : false;
        // if (rep_group_id === 8) {
        //   console.log(
        //     rep_group_id +
        //       ", rep_id=" +
        //       rep_id +
        //       ", rep_checked=" +
        //       rep_checked +
        //       ", rep_disable=" +
        //       rep_disable +
        //       ", item.name=" +
        //       item.name,
        //     user_group_relate_report,
        //     user_reports_access,
        //     user_countries_access,
        //     report_countries
        //   );
        // }
        return (
          <div key={"report-item-" + i} className="col s12 report-item">
            <div className="col s3">
              <Checkbox
                checked={rep_checked}
                filledIn
                id={"checkbox-report-item-" + rep_id}
                name="user_reports_access"
                className={"checkbox-report-item"}
                label={item.name}
                value={rep_id.toString()}
                onChange={handleEvents.OnChange}
                disabled={rep_disable}
              />
            </div>
            <div className="col s9">
              {countries.map((item, j) => {
                const coun_id = item.id;
                const foundCountryId =
                  user_countries_access.indexOf(coun_id) >= 0 ||
                  user_countries_access.indexOf(coun_id.toString()) >= 0
                    ? true
                    : false;
                let addClass = "";
                let country_checked = false;
                let country_disable = false;
                if (!rep_checked) {
                  addClass += " disable";
                  country_disable = true;
                } else if (rep_disable && foundCountryId) {
                  addClass += " disable active";
                  country_disable = true;
                } else if (rep_checked) {
                  if (foundCountryId) {
                    addClass += " active";
                    country_checked = true;
                    //country_disable = true;
                  } else if (
                    report_countries?.[rep_id]?.[coun_id] ||
                    report_countries?.[rep_id]?.[
                      -1
                    ] /* || rep_group_all_countries.indexOf(rep_group_id) >= 0*/
                  ) {
                    addClass += " active";
                    country_checked = true;
                  }
                } /* else {
                  country_disable = true;
                }*/

                // const label = <span className="lever">{item.code}</span>;
                // if (rep_group_id === 8) {
                //   console.log(
                //     item.code,
                //     coun_id,
                //     "foundCountryId=" + foundCountryId,
                //     "c_checked=" + country_checked,
                //     "c_disable=" + country_disable
                //   );
                // }
                return (
                  <div
                    key={"country-report-item-" + rep_id + "-" + j}
                    className={"checkbox-country-report-item comedy" + addClass}
                  >
                    {
                      <label>
                        <input
                          type="checkbox"
                          value={item.id}
                          checked={country_checked}
                          //id={"checkbox-countries-report-" + rep_id + "-" + j}
                          //name={"checkbox-countries-report[" + rep_id + "][]"}
                          name="report_countries"
                          repid={rep_id}
                          onChange={handleEvents.OnChange}
                          disabled={country_disable}
                        />
                        <span className="lever">{item.code}</span>
                      </label>
                    }
                    {/*<Checkbox
                                className={"lever"}
                                checked={country_checked}
                                filledIn
                                id={"checkbox-countries-report-"+rep_id+"-"+i}
                                name={"checkbox-countries-report["+rep_id+"][]"}
                                label={label}
                                value={item.code}
                            />*/}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
